import { flow, keyBy, map, noop } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import decodeCategory from '../normalizers/decodeCategory';
import switchFunc from '../utils/switchFunc';
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';
import { SPORTS_LIST } from '../constants/apiTypes';

const mapCategories = flow(map(decodeCategory), keyBy('slug'));

const initialState = {
  errors: [],
  hasInitialised: false,
  isFetching: false,
  items: {}
};

const apiRequestReducer = switchFunc(
  {
    [SPORTS_LIST]: () => ({
      errors: [],
      isFetching: true
    })
  },
  () => noop
);

const apiSuccessReducer = switchFunc(
  {
    [SPORTS_LIST]: (state, action) => ({
      hasInitialised: true,
      isFetching: false,
      items: mapCategories(action.data)
    })
  },
  () => noop
);

const apiFailureReducer = switchFunc(
  {
    [SPORTS_LIST]: (state, action) => ({
      errors: action.errors,
      isFetching: false
    })
  },
  () => noop
);

export default createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequestReducer(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccessReducer(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailureReducer(action.api)(state, action)
});
